import { Box, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EintragErstellenDialog from "./SchwarzesBrettEintraege";

import SearchIcon from "@mui/icons-material/Search";

export default function SearchHeader({ search, onSearchChange, onCreate, onChangeMitarbeiter }) {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Stack
        direction={{
          xs: "column",
          sm: "row",
        }}
        justifyContent="space-between"
        alignItems={{
          xs: "stretch",
          sm: "center",
        }}
        spacing={2}
      >
        <Typography
          variant="h5"
          fontWeight={700}
          sx={{
            fontSize: {
              xs: "1.5rem",
              sm: "1.8rem",
            },
          }}
        >
          {t("Schwarzes Brett")}
        </Typography>
      </Stack>

      <TextField
        fullWidth
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={t("Nach Meldungen suchen...")}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,

            backgroundColor: "background.default",

            height: {
              xs: 42,
              sm: 46,
            },
          },
        }}
      />
      {onCreate ? (
        <EintragErstellenDialog onChange={onChangeMitarbeiter} disabled={false} />
      ) : (
        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "66%",
            },
            height: 36,
            alignSelf: "center",
          }}
        />
      )}
    </Stack>
  );
}
